import React from "react";
import { Redirect } from "react-router-dom";

const Companies = () => {
  return <Redirect to="/settings?tab=companies" />;
};

export default Companies;
